/* DP currency v1 — display conversion with Shopify's own country + daily rates. No reloads. */
(function () {
  'use strict';
  var CTX = window.DPCUR_CTX || {};
  var PRES = CTX.pres || 'USD';
  var NATIVE = CTX.native || [];
  var KEY = 'dp:cur', RKEY = 'dp:rates';

  /* country -> local currency */
  var BY_COUNTRY = {
    JO: 'JOD', SA: 'SAR', AE: 'AED', KW: 'KWD', QA: 'QAR', OM: 'OMR', BH: 'BHD', IQ: 'IQD', EG: 'EGP',
    MA: 'MAD', PS: 'ILS', YE: 'YER', LB: 'LBP', SY: 'SYP', LY: 'LYD', TN: 'TND', DZ: 'DZD', SD: 'SDG',
    TR: 'TRY', GB: 'GBP', US: 'USD'
  };
  /* code: [label, decimals, Arabic name] */
  var FMT = {
    USD: ['$', 2, 'الدولار الأمريكي'], JOD: ['JD', 3, 'الدينار الأردني'], SAR: ['ر.س', 2, 'الريال السعودي'],
    AED: ['د.إ', 2, 'الدرهم الإماراتي'], KWD: ['د.ك', 3, 'الدينار الكويتي'], QAR: ['ر.ق', 2, 'الريال القطري'],
    OMR: ['ر.ع', 3, 'الريال العماني'], BHD: ['د.ب', 3, 'الدينار البحريني'], IQD: ['د.ع', 0, 'الدينار العراقي'],
    EGP: ['ج.م', 2, 'الجنيه المصري'], MAD: ['د.م', 2, 'الدرهم المغربي'], ILS: ['₪', 2, 'الشيكل (فلسطين)'],
    YER: ['ر.ي', 0, 'الريال اليمني'], LBP: ['ل.ل', 0, 'الليرة اللبنانية'], LYD: ['د.ل', 3, 'الدينار الليبي'],
    TND: ['د.ت', 3, 'الدينار التونسي'], DZD: ['د.ج', 2, 'الدينار الجزائري'], TRY: ['₺', 2, 'الليرة التركية'],
    GBP: ['£', 2, 'الجنيه الإسترليني'], EUR: ['€', 2, 'اليورو'],
    SDG: ['ج.س', 0, 'الجنيه السوداني'], SYP: ['ل.س', 0, 'الليرة السورية']
  };
  /* shown in the side-menu picker */
  var PICK = ['USD', 'JOD', 'SAR', 'AED', 'KWD', 'QAR', 'OMR', 'BHD', 'IQD', 'EGP', 'ILS', 'LBP', 'SYP', 'YER', 'LYD', 'TND', 'DZD', 'MAD', 'SDG', 'GBP', 'EUR', 'TRY'];

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }

  function autoCode() { return BY_COUNTRY[CTX.country] || PRES; }
  function target() {
    var m = lsGet(KEY);
    if (m && FMT[m]) return m;
    var a = autoCode();
    /* Shopify already shows a currency it supports natively for this country */
    if (NATIVE.indexOf(a) !== -1 && a !== PRES) return PRES;
    return FMT[a] ? a : PRES;
  }

  /* ---------- rates (USD value of 1 unit), from Shopify's daily file, cached 12h ---------- */
  var rates = null, waiting = [];
  function parseRates(t) {
    var m = t.match(/rates\s*:\s*\{([^}]*)\}/); if (!m) return null;
    var out = {}, re = /"?([A-Z]{3})"?\s*:\s*([0-9.eE+-]+)/g, x;
    while ((x = re.exec(m[1]))) out[x[1]] = parseFloat(x[2]);
    return out.USD ? out : null;
  }
  function loadRates(cb) {
    if (rates) return cb(rates);
    try { var c = JSON.parse(lsGet(RKEY) || 'null'); if (c && c.r && Date.now() - c.t < 12 * 3600e3) { rates = c.r; return cb(rates); } } catch (e) {}
    waiting.push(cb); if (waiting.length > 1) return;
    fetch('https://cdn.shopify.com/s/javascripts/currencies.js').then(function (r) { return r.text(); }).then(function (t) {
      var r = parseRates(t); if (r) { rates = r; lsSet(RKEY, JSON.stringify({ t: Date.now(), r: r })); }
    }).catch(function () {}).then(function () { var w = waiting; waiting = []; w.forEach(function (f) { f(rates); }); });
  }

  /* ---------- formatting ---------- */
  function parseAmount(s) {
    s = String(s).replace(/[^\d.,]/g, ''); if (!s) return NaN;
    var lastDot = s.lastIndexOf('.'), lastComma = s.lastIndexOf(',');
    var dec = Math.max(lastDot, lastComma), after = s.length - dec - 1;
    var presDec = FMT[PRES] ? FMT[PRES][1] : 2;
    if (dec !== -1 && after >= 1 && after <= 3 && (after !== 3 || presDec === 3)) {
      return parseFloat(s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1));
    }
    return parseFloat(s.replace(/[.,]/g, ''));
  }
  function fmt(v, code) {
    var f = FMT[code] || [code, 2], d = f[1];
    var n = v.toFixed(d).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var num = n.join('.');
    return code === 'USD' ? '$' + num : num + ' ' + f[0];
  }

  /* ---------- convert .money elements ---------- */
  var cur = PRES, busy = false;
  function convertEl(el) {
    var txt = el.textContent;
    if (el.dataset.dpOut && txt === el.dataset.dpOut && el.dataset.dpTo === cur) return;
    if (!el.dataset.dpOut || txt !== el.dataset.dpOut) el.dataset.dpOrig = txt; /* new/rewritten by theme JS */
    var orig = el.dataset.dpOrig;
    if (cur === PRES) { if (txt !== orig) el.textContent = orig; delete el.dataset.dpOut; el.dataset.dpTo = cur; return; }
    var a = parseAmount(orig);
    if (isNaN(a) || !rates || !rates[PRES] || !rates[cur]) return;
    var out = fmt(a * rates[PRES] / rates[cur], cur);
    el.dataset.dpOut = out; el.dataset.dpTo = cur;
    if (txt !== out) el.textContent = out;
  }
  function run(root) {
    busy = true;
    (root || document).querySelectorAll('.money').forEach(convertEl);
    busy = false;
  }
  function note() {
    var old = document.querySelector('.dp-cur-note');
    if (cur === PRES) { if (old) old.remove(); return; }
    var host = document.querySelector('.dpc-items') || document.querySelector('[data-dp-cur-note]');
    if (!host) return;
    var html = 'الأسعار معروضة بـ<b>' + (FMT[cur] ? FMT[cur][2] : cur) + '</b> للتوضيح، والدفع يتم بـ<b>' + (FMT[PRES] ? FMT[PRES][2] : PRES) + ' (' + PRES + ')</b>';
    if (old) { old.innerHTML = html; return; }
    var n = document.createElement('div'); n.className = 'dp-cur-note'; n.innerHTML = html;
    host.insertBefore(n, host.firstChild);
  }
  function apply() {
    cur = target();
    var done = function () { run(); note(); document.documentElement.classList.remove('dp-cur-wait'); document.dispatchEvent(new CustomEvent('dp:currency', { detail: { code: cur } })); };
    if (cur === PRES) return done();
    loadRates(function (r) { if (!r) cur = PRES; done(); });
  }

  new MutationObserver(function (muts) {
    if (busy || cur === PRES || !rates) return;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target, el = t.nodeType === 1 ? t : t.parentElement;
      if (el && el.closest) { var m = el.closest('.money'); if (m) convertEl(m); }
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) {
        if (added[j].classList.contains('money')) convertEl(added[j]); else if (added[j].querySelector('.money')) run(added[j]);
      }
    }
    if (document.querySelector('.dpc-items') && !document.querySelector('.dp-cur-note')) note();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  window.DPCUR = {
    list: PICK, names: FMT, pres: PRES, auto: autoCode,
    current: function () { return cur; },
    manual: function () { return lsGet(KEY); },
    set: function (code) { lsSet(KEY, code && FMT[code] ? code : null); apply(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  setTimeout(function () { document.documentElement.classList.remove('dp-cur-wait'); }, 2500);
})();
